<app-loader *ngIf="pageLoader"></app-loader>
<app-error-message *ngIf="errorMessage" (try)="tryAgain()"></app-error-message>
<div class="container" *ngIf="!pageLoader && !errorMessage">
  <div class="row align-items-center header-section">
    <div class="col-12">
      <app-return></app-return>
      <h3 class="cm-title">Consulta por mes</h3>
    </div>
  </div>
  <div class="row mb-4 m-0 right-week-table-row">
    <div class="col-lg-5 right-week-table">
      <div class="row top-row-right-table">
        <div class="col-lg-6 justify-content-lg-center align-items-center d-flex mb-2 mb-lg-0">
          <div>Año</div>
        </div>
        <div class="col-lg-6 v-line-rt justify-content-lg-center d-flex">
          <div>Mes</div>
        </div>
      </div>
      <div class="row top-row-right-table">
        <div class="col-lg-6 justify-content-lg-center align-items-center d-flex mb-2 mb-lg-0">
          <div>{{ yearAndMonthSelected[0] || "Año" }}</div>
        </div>
        <div class="col-lg-6 v-line-rt justify-content-lg-center d-flex">
          <div>{{ monthName || "Mes"}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-12">
          <form class="example-form">
            <!--<mat-form-field class="w-50" appearance="legacy">
                          <mat-label>No. identificación</mat-label>
                          <input type="search" matInput placeholder="">
                        </mat-form-field>-->
            <mat-form-field appearance="outline" class="custom-field mb-2 d-none">
              <mat-label>CRM</mat-label>
              <mat-select formControlName="crm">
                <mat-option value="Poliedro">Poliedro</mat-option>
                <mat-option value="Visor">Visor</mat-option>
                <mat-option value="Inspira">Inspira</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="col-12">
          <div class="rp-tableST">
            <table mat-table [dataSource]="data | slice:lowValue : highValue" class="custom_tableST text-center"
              *ngIf="data">

              <ng-container matColumnDef="fecha">
                <th mat-header-cell *matHeaderCellDef class="text-center"> FECHA </th>
                <td mat-cell *matCellDef="let element"> {{ element.date }}</td>
              </ng-container>

              <!--<ng-container matColumnDef="tipo-documento">
                <th mat-header-cell *matHeaderCellDef class="text-center"> TIPO DE DOCUMENTO </th>
                <td mat-cell *matCellDef="let element"> ATDP, Contrato, Póliza </td>
              </ng-container>-->

              <ng-container matColumnDef="tipo-documento">
                <th mat-header-cell *matHeaderCellDef class="text-center"> TIPO DE DOCUMENTO </th>
                <td mat-cell *matCellDef="let element"> Contratos </td>
              </ng-container>

              <ng-container matColumnDef="crm">
                <th mat-header-cell *matHeaderCellDef class="text-center"> CRM </th>
                <td mat-cell *matCellDef="let element"> Todos </td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="text-center"> ESTADO </th>
                <td mat-cell *matCellDef="let element"><span>Exitoso</span></td>
              </ng-container>

              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef class="text-center"> TOTAL </th>
                <td mat-cell *matCellDef="let element"> {{ element.total }} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="getPaginatorData($event)" aria-label="Select page">
          </mat-paginator>
        </div>
      </div>
    </div>
    <div class="col-lg-6 ">
      <div class="row">
        <div class="col-12 d-flex justify-content-lg-end">
          <!--<mat-form-field class="w-50" appearance="legacy">
                        <mat-label>Tipo de documento</mat-label>
                        <mat-select>
                          <mat-option></mat-option>
                        </mat-select>
                    </mat-form-field>-->
          <!--<h2>Poliedro</h2>-->
        </div>
        <div class="col-12 d-flex justify-content-lg-end border rounded">
          <app-line-graph *ngIf="dataGraph" [data]="dataGraph" [data2]="null"></app-line-graph>
        </div>
      </div>
    </div>
  </div>
</div>
